import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { 
    BrowserCacheLocation, 
    InteractionType, 
    IPublicClientApplication, 
    LogLevel, 
    PublicClientApplication 
} from '@azure/msal-browser';
import { environment } from 'environments/environment';

export function loggerCallback(logLevel: LogLevel, message: string) {
    // console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            // Cliente ID de tu aplicación en Azure AD
            // IMPORTANTE: Reemplaza este valor con tu Client ID real
            clientId: environment.msalConfig?.clientId || 'TU_CLIENT_ID_AQUI',
            
            // Para permitir cualquier cuenta personal o de organización
            authority: 'https://login.microsoftonline.com/common',
            
            // URL de redirección después del login
            redirectUri: environment.msalConfig?.redirectUri || window.location.origin,
            
            // URL de redirección después del logout
            postLogoutRedirectUri: environment.msalConfig?.postLogoutRedirectUri || window.location.origin
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
            storeAuthStateInCookie: false, // Set to true for IE 11
        },
        system: {
            loggerOptions: {
                loggerCallback,
                logLevel: LogLevel.Info,
                piiLoggingEnabled: false
            }
        }
    });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    
    // Agregar los recursos que quieres proteger con tokens de Microsoft
    // protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: ['user.read', 'openid', 'profile', 'email']
        },
        loginFailedRoute: '/sign-in'
    };
}
